import { ThemeColors } from '../theme-colors';
import { ColorPalette } from '../../base/colorPalette';

export const Treeview = {};

export const CustomTreeview = {
	treeviewItemPaddingV: 'var(--epods--treeview-item-padding-v)',
	treeviewItemPaddingH: 'var(--epods--treeview-item-padding-h)',
	treeviewChevronSize: 'var(--epods--treeview-chevron-size)',

	treeviewBorderColor: 'var(--epods--treeview-border-color)',
	treeviewBorderColorSelected: 'var(--epods--treeview-border-color-selected)',
	treeviewBorderStyle: 'var(--epods--treeview-border-style)',
	treeviewBorderWidth: 'var(--epods--treeview-border-width)',
};
